import { Box, Grid, List, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { formatCurrency } from "@roc/ui/utils";
import { isNil } from "@roc/feature-utils";
import { Button, Paper, PaperBorderType } from "@roc/ui";
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme: Theme) => ({}));

export const PayoffReconciliationFieldsCard = observer(({store}) => {
  const divider = <Box my={1} borderBottom={1} borderColor="grey.300" />;
  const listItem = (label, value) => (
    <Box display="flex" justifyContent="space-between" py={0.5}>
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2" color="textSecondary">{value}</Typography>
    </Box>
  );

  return (
    <Paper titleComponent={
      <Box display="flex" p={2}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h5">
              Payoff Reconciliation
            </Typography>
          </Grid>
        </Grid>
      </Box>
    } borderType={PaperBorderType.SOLID_BORDER}>
      <Grid container style={{ padding: '0px 16px 16px' }} spacing={2}>
        <Grid item xs={6}>
          <List style={{ padding: '0px' }}>
            {listItem('Good Through Date', store?.goodThroughDate ?? '-')}
            {divider}
            {listItem('Reserve Fees if Any', !isNil(store?.reserveFees) ? formatCurrency(store?.reserveFees) : '-')}
            {divider}
            {listItem('To Charges Principal', !isNil(store?.toChargesPrincipal) ? formatCurrency(store?.toChargesPrincipal) : '-')}
            {divider}
            {listItem('Waiver Amount', !isNil(store?.waiverAmount) ? formatCurrency(store?.waiverAmount) : '-')}
            {divider}
            {listItem('Waiver Description', store?.waiverDescription ?? '-')}
            {divider}
            {listItem('Comments', store?.payoffComments ?? '-')}

          </List>
        </Grid>
        <Grid item xs={6}>
          <List style={{ padding: '0px' }}>
            {listItem('Unpaid Balance', !isNil(store?.fundedAmount) ? formatCurrency(store?.fundedAmount) : '-')}
            {divider}
            {listItem('Total Extension Fee', !isNil(store?.totalExtensionFee) ? formatCurrency(store?.totalExtensionFee) : '-')}
            {divider}
            {listItem('Prepayment Penalty', !isNil(store?.prepaymentPenalty) ? formatCurrency(store?.prepaymentPenalty) : '-')}
            {divider}
            {listItem('Other Fees', !isNil(store?.otherFeesAdjustment) ? formatCurrency(store?.otherFeesAdjustment) : '-')}
            {divider}
            {listItem('Other Fees Categories', store?.otherFeesCategories ?? '-')}
          </List>
        </Grid>
      </Grid>
    </Paper>
  );
});
